import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import Overlay from 'ol/Overlay.js';
import { fromLonLat } from 'ol/proj';
import { Circle as CircleStyle, Fill, Stroke, Style, Icon } from 'ol/style.js';

export const userMarker = new Feature();
userMarker.setStyle(
	new Style({
		image: new CircleStyle({
			radius: 6,
			fill: new Fill({
				color: [246, 85, 150, 1]
			}),
			stroke: new Stroke({
				color: '#fff',
				width: 2
			})
		})
	})
);

export const userMarkerAccuracy = new Feature();
userMarkerAccuracy.setStyle(
	new Style({
		fill: new Fill({
			color: [246, 85, 150, 0.1]
		})
	})
);

export const vendorMarker = vendor => {
	const { lng, lat } = vendor;
	const vendorLocation = fromLonLat([lng, lat]);

	return new Feature({
		geometry: new Point(vendorLocation)
	});
};

export const vendorMarkerStyle = (avatar = '/static/placeholder.png') => [
	new Style({
		image: new Icon({
			scale: 0.3,  // Smaller pin
			src: '/static/marker.png'
		})
	}),
	new Style({
		image: new Icon({
			scale: 1.0,  // Scale 1.0 for 50px circular avatars
			src: avatar,
			anchor: [0.5, 0.7],  // Center horizontally, position in upper part of pin
			anchorXUnits: 'fraction',
			anchorYUnits: 'fraction'
		})
	})
];

export const popupOverlay = new Overlay({
	element: document.querySelector('.popup'),
	positioning: 'bottom-center',
	stopEvent: true,
	offset: [0, -50]
});
